import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export const useGetHrmSettings = (companyId, enabled = true) => {
    const intl = useIntl();
    return useQuery([SettingsQueryKey.HrmSettings, companyId], () => api.base
        .get('/api/settings/hrm', { params: { id: companyId } })
        .then(res => res.data), {
        enabled: !!companyId && enabled,
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    });
};
